import React from 'react';
import ReactDOMServer from 'react-dom/server';

import { CompanyIcon, ProjectIcon } from 'app/components/DetailsPages/shared/CommonGround/Icons';
import MugsIcon from 'app/components/shared/icons/mugs-icon';

import { IDrawer } from '../../../PublicationContent';
import './styled';
import {
  DataTypeMemberCompanyIconContainer,
  DataTypeMemberCompanyPillText,
  DataTypeMemberCompanyPillWrapper,
  DataTypeSubsidiaryIconContainer,
  DataTypeSubsidiaryPillText,
  DataTypeSubsidiaryPillWrapper,
} from './styled';

export const dataTypeMemberCompanyContentModifier = (
  node: HTMLDivElement,
  setDrawer: React.Dispatch<React.SetStateAction<IDrawer>>
) => {
  node
    .querySelectorAll(
      '[data-type="member_companies"], [data-type="company"], [data-type="member-company"]'
    )
    .forEach((company) => {
      const slug = company.getAttribute('data-slug');
      const name = company.textContent;
      const template = document.createElement('div');
      const isSubisidiary =
        company.getAttribute('data-subsidiary') &&
        company.getAttribute('data-subsidiary') === 'true';

      template.innerHTML = ReactDOMServer.renderToString(
        isSubisidiary ? (
          <DataTypeSubsidiaryPill name={name || ''} />
        ) : (
          <DataTypeMemberCompanyPill name={name || ''} />
        )
      );

      template.firstChild.addEventListener('click', () => {
        setDrawer({ show: true, slug, type: 'member_companies' });
      });

      company.replaceWith(template.firstChild);
    });
};

interface DataTypeMemberCompanyPillProps {
  name: string;
}

export const DataTypeMemberCompanyPill = ({ name }: DataTypeMemberCompanyPillProps) => {
  return (
    <DataTypeMemberCompanyPillWrapper>
      <DataTypeMemberCompanyIconContainer>
        <CompanyIcon width={16} height={16} fill={'var(--color-data-company-foreground)'} />
      </DataTypeMemberCompanyIconContainer>
      <DataTypeMemberCompanyPillText>{name}</DataTypeMemberCompanyPillText>
    </DataTypeMemberCompanyPillWrapper>
  );
};

interface DataTypeSubsidiaryPillProps {
  name: string;
}

export const DataTypeSubsidiaryPill = ({ name }: DataTypeSubsidiaryPillProps) => {
  return (
    <DataTypeSubsidiaryPillWrapper>
      <DataTypeSubsidiaryIconContainer>
        <MugsIcon width={16} height={16} fill={'var(--color-data-company-foreground)'} />
      </DataTypeSubsidiaryIconContainer>
      <DataTypeSubsidiaryPillText>{name}</DataTypeSubsidiaryPillText>
    </DataTypeSubsidiaryPillWrapper>
  );
};
